export class DataCatalogAccessPolicy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "kind",
            "baseName": "kind",
            "type": "DataCatalogPolicyKind",
            "format": ""
        },
        {
            "name": "scope",
            "baseName": "scope",
            "type": "DataCatalogPolicyScope",
            "format": ""
        },
        {
            "name": "subjects",
            "baseName": "subjects",
            "type": "DataCatalogSubjectSet",
            "format": ""
        },
        {
            "name": "rowFilter",
            "baseName": "rowFilter",
            "type": "DataCatalogRowFilterPolicyBody",
            "format": ""
        },
        {
            "name": "masking",
            "baseName": "masking",
            "type": "DataCatalogMaskingPolicyBody",
            "format": ""
        },
        {
            "name": "validFrom",
            "baseName": "validFrom",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "expiresAt",
            "baseName": "expiresAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "DataCatalogGrantStatus",
            "format": ""
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "createdBy",
            "baseName": "createdBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedBy",
            "baseName": "updatedBy",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogAccessPolicy.attributeTypeMap;
    }
    constructor() {
    }
}
